import { Icon, Modal, Button, Spin, message, AutoComplete } from "antd";
import ConfirmationModal from "./confirmation-modal";
import DataHandler from "../utils/DataHandler";
import { Translate } from "react-translated";
import React, { Component } from "react";
import F from "../Functions";
import axios from "axios";
import { DEACTIVATE_USER } from "../utils/Api_enums";

const antIcon = <Icon type="loading" style={{ fontSize: 24 }} spin />;

class DashModal extends Component {
  state = {
    loading: false,
    assigned_rs_id: null,
    action: "add_manually",
    cols: [],
    showUploadListConfirmationModal: false
  };

  deactivateAndTransferFiles = () => {
    // payload
    const data = {
      deactivate_rs_id: this.props.deactivatedUser.id,
      assigned_rs_id: this.state.assigned_rs_id
    };

    this.setState({
      loading: true
    });

    axios
      // .put("/api/user/" + this.props.deactivatedUser.id, {
      //   active: 0
      // })
      .put(DEACTIVATE_USER + this.props.deactivatedUser.id)
      .then((res) => {
        // handle callback
        message.destroy();
        if (res.data.success === true) message.success("User deactivated successfully !!!");
        else message.error(res.data.message);
        this.props.loadUsers(1);
        const callback = DataHandler.getReviewSchedulerListCallback();
        this.props.hideModal()
        callback && callback();
      }).catch((error) => {
        F.log(error);
        this.setState({
          loading: false
        });

      });



    // axios
    //   .post("/api/deactivate_rs_and_transfer_files", data)
    //   .then((res) => {
    //     this.setState({
    //       loading: false
    //     });

    //     const response = res.data;

    //     if (response.success) {
    //       message.success(response.message);

    //       // Call API
    //       axios
    //         .put("/api/user/" + this.props.deactivatedUser.id, {
    //           active: 0
    //         })
    //         .then(() => {});

    //       // handle callback
    //       const callback = DataHandler.getReviewSchedulerListCallback();
    //       callback && callback();
    //     } else {
    //       message.error(response.message);
    //     }

    //     this.props.hideModal();
    //   })
    // .catch((error) => {
    //   F.log(error);
    //   this.setState({
    //     loading: false
    //   });
    // });
  };

  validateFieldsSuccess = () => {
    const { assigned_rs_id } = this.state;

    // reset notification
    message.destroy();

    if (assigned_rs_id === null) {
      message.error(F.translate(`Please select Review Scheduler.`));
      return false;
    }

    return true;
  };

  save = () => {
    // reset notification
    message.destroy();

    if (this.validateFieldsSuccess()) {
      this.setState({ showUploadListConfirmationModal: true });
    }
  };

  renderFooter = () => {
    return (
      <div>
        <Button type="primary"
          className="borderRadius-28"
          onClick={() => this.save()}>
          <Translate text={`Deactivate`} />
        </Button>
        <Button
          className="borderRadius-28"
          onClick={() => this.props.hideModal()}>
          <Translate text={`Cancel`} />
        </Button>
      </div>
    );
  };

  onSelectAgency = (val) => {
    // handle crash for empty value "select" from the drop down
    if (typeof val === "string" && val === "") {
      this.setState({
        assigned_rs_id: null
      });
    } else {
      let item = this.props.rs_users.find((user) => user.name === val);
      if (item && Object.keys(item).length > 0) {
        this.setState({
          assigned_rs_id: item.id
        });
      }
    }
  };

  renderRSListDropDown = () => {
    const dataSource = this.props.rs_users.map((user) => user.name);

    return (
      <div style={{ marginBottom: 10 }}>
        {/* <label>
          <Translate text={`Review Scheduler`} />
        </label> */}
        <AutoComplete
          style={{ width: "100%" }}
          dataSource={dataSource}
          placeholder="Select"
          onSelect={this.onSelectAgency}
          onSearch={this.onSelectAgency}
          allowClear
          filterOption={(inputValue, option) =>
            option.props.children
              .toUpperCase()
              .indexOf(inputValue.toUpperCase()) !== -1
          }
        />
      </div>
    );
  };

  renderDescription = () => {
    const { deactivatedUser } = this.props;
    return (
      <p>
        <span>
          {`Select a Review Scheduler to move all Agencies and B Files that are currently assigned to `}
          <span style={{ fontWeight: "bold" }}>
            {deactivatedUser.first_name + " " + deactivatedUser.last_name}
          </span>
        </span>
      </p>
    );
  };

  confirmAction = () => {
    this.setState({ showUploadListConfirmationModal: false }, () => {
      this.deactivateAndTransferFiles();
    });
  };

  cancelAction = () => {
    this.setState({ showUploadListConfirmationModal: false });
  };

  render() {
    const { loading } = this.state;
    const { deactivatedUser } = this.props;

    return (
      // <Modal
      //   // title={<Translate text={`Deactivate Review Scheduler`} />}
      //   title={`Deactivate "${deactivatedUser.first_name +
      //     " " +
      //     deactivatedUser.last_name}"`}
      //   // this.props.deactivatedUser
      //   // visible={this.props.showModal}
      //   // onCancel={this.props.hideModal}
      //   footer={this.renderFooter()}
      // >
      // <Spin indicator={antIcon} spinning={loading}>
      //   <div className="formBox">
      //     {this.renderDescription()}

      //     {this.renderRSListDropDown()}
      //   </div>
      // </Spin>
      <ConfirmationModal
        // showModal={this.state.showUploadListConfirmationModal}
        showModal={this.props.showModal}
        title="Deactivate"
        okText="Yes"
        cancelText="No"
        message="Are you sure you want to deactivate?"
        ok={this.confirmAction}
        // cancel={this.cancelAction}
        cancel={this.props.hideModal}
      />
      // </Modal>
    );
  }
}

export default DashModal;



// WEBPACK FOOTER //
// ./src/components/deativate-review-scheduler.js